import React, {useEffect, useState} from 'react';
import CustomSelect from "../form/CustomSelect";
import { GetShippingMethods } from "../../api/shipping-addresses/getShippingMethods";
import {useTranslation} from "react-i18next";

const ShippingMethodSelect = (props) => {

    const { t } = useTranslation();

    const [availableShippingMethods, setAvailableShippingMethods] = useState([]);

    useEffect(() => {
        const requestShippingMethods = async function (){
            try {
                const data = await GetShippingMethods();
                setAvailableShippingMethods(data);
            } catch (err){
                console.log("Error fetching user roles: " + err);
            }
        }
        requestShippingMethods();
    }, []);

    return (
        <CustomSelect
            placeholder={<div>{t("Select shipping method")}</div>}
            options={availableShippingMethods}
            onChange={props.onChange}
            value={availableShippingMethods.find(option =>
                option.value && props.value && option.value.toLowerCase() === props.value.toLowerCase()
            )}
        />
    );
};

export default ShippingMethodSelect;
